import { create } from "zustand";

type State = {
  companyId: number | undefined;
  couponsPermission: boolean;
  students: CouponStudent[];
  tableMetadata: CouponTableMetada;
  isToastOpen: boolean;
};

type Action = {
  setCompanyId: (companyId: number | undefined) => void;
  setCouponsPermission: (couponsPermission: boolean) => void;
  setStudents: (students: CouponStudent[]) => void;
  addStudents: (students: CouponStudent[]) => void;
  setTableMetadata: (tableMetadata: CouponTableMetada) => void;
  setIsToastOpen: (isToastOpen: boolean) => void;
};

const useCouponsStudents = create<State & Action>((set) => ({
  companyId: 0,
  couponsPermission: false,
  students: [],
  tableMetadata: {
    count: 1,
    pages: 1,
    current_page: 1,
  },
  setCompanyId: (companyId) => set(() => ({ companyId })),
  setCouponsPermission: (couponsPermission) => set(() => ({ couponsPermission })),
  setStudents: (students) => set(() => ({ students })),
  addStudents: (students) => set((state) => ({ students: [...state.students, ...students] })),
  setTableMetadata: (tableMetadata) => set(() => ({ tableMetadata })),
  isToastOpen: false,
  setIsToastOpen: (isToastOpen) => set(() => ({ isToastOpen })),
}));

export default useCouponsStudents;
